import React from 'react';
import { Box, styled } from '@mui/material';

const StyledDefaultLayoutMain = styled(({ drawerWidth, ...otherProps }) => <Box {...otherProps} />)(
  ({ drawerWidth, theme }) => ({
    backgroundColor: theme.palette.gray2.main,
    flexGrow: 1,
    maxWidth: '100%',
    // Sin esto un hijo ancho (una fila que no encoge) haría crecer el item flex por encima del
    // viewport y el lienzo dejaría de pintar toda la pantalla en móvil.
    minWidth: 0,
    minHeight: '100vh',
    // Ya no hay bottom nav que despejar; solo un respiro inferior.
    paddingBottom: theme.spacing(2),
    transition: `width ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut} 0ms`,
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(5),
      width: `calc(100% - ${drawerWidth}px)`
    }
  })
);

export default StyledDefaultLayoutMain;
